export default function ClinicalNoteActivityFeedIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.00012207" width="28" height="28" rx="14" fill="#2C0817" />
      <g clip-path="url(#clip0_5075_4853)">
        <path
          d="M21.4134 11.8374C21.5227 11.728 21.5841 11.5797 21.5841 11.4251C21.5841 11.2704 21.5227 11.1221 21.4134 11.0127L16.9903 6.58741C16.8809 6.47809 16.7326 6.41669 16.5779 6.41669C16.4233 6.41669 16.275 6.47809 16.1656 6.58741L11.9875 10.7772C11.9875 10.7772 9.96404 9.76584 7.80279 11.51C7.7387 11.5613 7.68616 11.6256 7.6486 11.6986C7.61105 11.7716 7.58932 11.8517 7.58485 11.9336C7.58038 12.0156 7.59326 12.0976 7.62264 12.1742C7.65203 12.2509 7.69727 12.3205 7.75539 12.3784L15.6231 20.2454C15.682 20.3039 15.7528 20.3492 15.8306 20.3781C15.9084 20.4071 15.9915 20.4191 16.0743 20.4134C16.1571 20.4076 16.2378 20.3843 16.3109 20.3449C16.384 20.3055 16.4478 20.251 16.4981 20.1849C17.1099 19.3712 18.0709 17.6992 17.2353 16.0287L21.4134 11.8374Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.6881 16.3123L8.16699 19.8335"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5075_4853">
          <rect
            width="18.6667"
            height="18.6667"
            fill="white"
            transform="translate(4.66699 4.66681)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
